module.exports = __webpack_public_path__ + "static/hallway-26a41fbe54442fdafbeb7fa6568ffb8e.jpg";